<template>

  <v-dialog v-model="intDialogVisible" max-width="800px" class="addValueModal addComment">
      <div class="modeSelector">
        <div class="titleModeSelector">
            Select an account to access
        </div>
        <div class="selectors">
          <div class="labelSelectorContainer">
            <input type="radio" name="chosen_user" id="myself" value="-1" v-model="chosen_user" />
            <label  for="myself" class="realSelector2">
                <div class="titleMode">
                  Your account
                </div>

            </label>
          </div>
          <div class="labelSelectorContainer" v-for="(user, u) in list_of_user" :key="u">
            <input type="radio" name="chosen_user" :id="user._id.$oid" :value="user._id.$oid" v-model="chosen_user" />
            <label  :for="user._id.$oid" class="realSelector2">
                <div class="titleMode">
                  Customer account<br/>
                  <small v-if='user.entreprise'>{{user.entreprise}}</small>
                  <small v-else>{{user.firstname}} {{user.lastname}}</small>

                </div>

            </label>
          </div>

          <!-- <div class="labelSelectorContainer">
            <input type="radio" name="chosen_user" id="AImode" value="AI" v-model="chosen_user" />
            <label  for="AImode" class="realSelector">
                <div class="titleMode">
                  I want to identify innovation topics and partners with PearlAI
                </div>
                <div class="diviser">

                </div>
                <div class="imageSelecot">
                  <img :src="require('@/assets/aiMode.png')" class="" alt="">

                </div>
            </label>
          </div> -->

        </div>
        <div class="actions_project_mode">
          <button class="confirmButton" type="button" name="button" @click="handleConnect" :disabled="chosen_user == null">Connect</button>
        </div>
      </div>
</v-dialog>
</template>
<script>
export default {
  components: {
  },
  props: {
    dialogVisible: Boolean,
    list_of_user : Array,
  },
  name: 'chosen_userModal',
  data() {
    return {
      chosen_user:null,
    }
  },
  methods:{
    handleConnect(){
    this.$emit('choiceMade',this.chosen_user);
    },
    cancel(){
      this.$emit("cancelChoice");
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
    }
  }
}
</script>
<style scoped>

.modeSelector{
  padding:20px;
  background:#FFF;
  border-radius:20px;
  border:1px solid #D6E2EC;
}
.titleModeSelector{
  color:#3783C5;
  font-size:27px;
  font-weight:600;
  width:100%;
  text-align:center;
}
.titleMode small{
  font-size:12px;
}

.subtitleModeSelector{
  color:#000;
  font-size:20px;
  width:100%;
  text-align:center;
}

.selectors{
  display: flex;
    flex-wrap: wrap;
    gap:40px;
    margin-top:40px;

}
.selectors > div.labelSelectorContainer{
  flex:1;
}

.selectors input{
display: none;
}

.realSelector2{
  outline:1px solid #D6E2EC;
  background:#F0F5FA;
  padding-top: 20px;
    padding-bottom: 20px;
  padding-left: 25px;
  padding-right: 25px;
  border-radius:20px;
  align-items: center;
  display: flex;
  flex-direction: column;
  height:100%;
  justify-content: center;
}

.selectors input:checked ~ .realSelector2{
  outline:2px solid #3783C5;
}

.titleMode{
  color:#000;
  font-size:16px;
  font-weight: 600;
  width:100%;
  text-align:center;
}
.diviser{
  width:100%;
  height:25px;
}

.imageSelecot{
  margin-top:auto;
}

.actions_project_mode{
  display:flex;
  flex-wrap: wrap;
  gap:15px;
  margin-top:40px;
  justify-content: center;
  align-items: center;
}


.cancelButton{
  background:#FFF;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px 30px;
  color: #3783C5;
  text-transform:uppercase;

}
.confirmButton{

    border: 1px solid #3783C5;
    border-radius: 25px;
    padding: 10px 30px;
    background: #3783C5;
    color: #FFF;
    text-transform:uppercase;
}
.confirmButton:disabled{
  opacity:.8;
}

</style>
